import { render } from "./schools-city.vue?vue&type=template&id=1ec3206e"
import script from "./schools-city.js?vue&type=script&lang=js"
export * from "./schools-city.js?vue&type=script&lang=js"

import "./schools-city.vue?vue&type=style&index=0&id=1ec3206e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__